import Vue from 'vue'
import Constants from '@/application/constants'

export default {
  async getParents({
    limit,
    page,
    minutes,
    isActive,
    deactiveReason,
    search,
    orderParam,
    orderType
  }) {
    return Vue.axios.get(
      '/parents/',
      {
        baseURL: Constants.USERS_API_URL,
        params: {
          limit,
          page,
          minutes,
          isActive,
          deactiveReason,
          search,
          orderParam,
          orderType
        },
      }
    )
  },

  async deactivate({ parentId, reasonId, isActive }) {
    return Vue.axios.patch(
      `parents/${parentId}/status/`,
      {
        reasonID: reasonId,
        isActive,
      },
      { baseURL: Constants.USERS_API_URL }
    )
  },

  async getParentAttributes(parentId) {
    return Vue.axios.get(
      `/parents/${parentId}/attributes/`,
      { baseURL: Constants.USERS_API_URL }
    )
  },

  async getSubjects(parentId) {
    return Vue.axios.get(`/parents/${parentId}/subjects`, { baseURL: Constants.USERS_API_URL })
  },

  async setSubjects (userID, subjectsID) {
    return Vue.axios.patch(`/parents/${userID}/subjects/`, { subjectsID }, { baseURL: Constants.USERS_API_URL })
  }
}
